<template>
    <div class="layout"
         :style="{'grid-template-columns': gridColumns}">
        <div class="tabWrap" v-for="tab in tabOptions" :key="tab.key"
             @mouseover="hover = tab.key"
             @mouseleave="hover = null"
             :class="{'tabsDisabled': tab.disabled, selected: isTabSelected = (tab.key === selectedTab)}"
             @click="tab.disabled || (selectTab(tab.key))"
             :id="`tab${tab.key}`">
            <div>
                <div class="tabContentWrap">
                    <span class="iconWrap">
                        <IconBase :iconName="tab.icon" :iconColor="getIconColor(tab)"
                                  :width="tab.iconWidth" :height="tab.iconHeight"></IconBase>
                    </span>
                    <Tooltip :text="tab.text" class="tabsName font-6">
                        {{ tab.text }}
                    </Tooltip>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import IconBase from 'components/IconBase.vue';
import Tooltip from 'components/Tooltip/Tooltip.vue';
import consts from 'services/metaData/consts';

export default {
    name: 'Tabs',
    components: { Tooltip, IconBase },
    props: {
        tabOptions: {
            type: Array,
            validator: (tabs) => tabs.some((tab) => !tab.key || !tabs.icon || !tabs.text)
        },
        selectedTab: [String, Number]
    },
    data() {
        return {
            hover: null
        };
    },
    computed: {
        gridColumns() {
            return (new Array(this.tabOptions.length)).fill('1fr').join(' ');
        }
    },
    methods: {
        getIconColor(tab) {
            if (this.selectedTab === tab.key || this.hover === tab.key) {
                return consts.COLORS.PRIMARY_500;
            }
            if (tab.disabled) {
                return consts.COLORS.LIGHT_600;
            }
            return consts.COLORS.LIGHT_700;
        },
        selectTab(tabKey) {
            this.$emit('selectionChanged', tabKey);
        }
    }
};
</script>

<style scoped lang="scss">
    @import "~styles/styleGuide";
    $disabledTabFont: $light-600;
    $tabsNameColor: $light-700;

    .layout {
        display: grid;
        grid-template-rows: 70px;
        background-color: $white;
    }

    .tabWrap {
        cursor:pointer;
        min-width: 0; // for ellipsis text
        &.selected{
            border-bottom: 3px solid $selectedColor;
            background-color: $primary-100;
        }
        &.selected .tabsName, &:hover .tabsName {
            color: $selectedColor;
        }

        &.disabled {
            color: $disabledTabFont;
            cursor: default;

            .tabsName {
                color: $disabledTabFont;
            }

            &:hover .tabsName {
                color: $disabledTabFont;
            }
        }
    }
    .tabsDisabled {
        cursor: default;

        .tabsName {
            color: $disabledTabFont;
        }

        &:hover .tabsName {
            color: $disabledTabFont;
        }
    }

    .tabsName {
        min-height: 16px;
        color: $tabsNameColor;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        padding-top: 2px;
        display: block;
    }

    .tabContentWrap{
        text-align: center;
        height: 67px; //70px - 3px (border)
        padding-top: 15px;
    }
</style>
